
const sale            = require('../applications/staff/desktop/entity/sale/sale')
const purchase        = require('../applications/staff/desktop/entity/purchase/purchase')
const warehousepurchase        = require('../applications/warehouse/entity/warehousepurchase/warehousepurchase')
const warehousesale        = require('../applications/warehouse/entity/warehousesale/warehousesale')
//tv
const staffTv         = require ('../applications/staff/tv/staff-tv')

export const obj = {
        sale:       { start: function(detail){ sale.start(detail)        }},
        purchase:       { start: function(detail){ purchase.start(detail)        }},
        warehousepurchase:{ start: function(detail){ warehousepurchase.start(detail)    }},
        warehousesale:    { start: function(detail){ warehousesale.start(detail)        }},
}